import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async getDocusignAccountInfo() {
      const response = await http.get(`setting/docusign/account`)

      return response
    },
  },
}
